<template>
	<div>
       <a-modal v-model="visible" 
	    title="损耗" cancelText="取消" okText="确定" @ok="savefn">
		   <div v-for="item in datainfo.hetonglingquinfo"  class="inputcontainer">
				<div class="itemcontainer">
					<span>材料:</span><a-input v-model="item.type"/>
				</div>
				<div class="itemcontainer">
					<span>单价:</span><a-input v-model="item.price"/>
				</div>
				<div class="itemcontainer">
					<span>数量:</span><a-input v-model="item.number"/>
				</div>
				<div class="itemcontainer">
					<span>损耗:</span><a-input v-model="item.sunhao"/>
				</div>
				<div class="itemcontainer">
					<span>总价:</span><a-input v-model="item.total"/>
				</div>
		   </div>
	   </a-modal>
	</div>
</template>
<script>
import {sunhao} from '@/api/contract.js';
import {message} from "ant-design-vue"

export default {
	data(){
		return {
			visible:false,	
			datainfo:{id:0,hetonglingquinfo:[]}
		}
	},
	methods:{
		showsunhao(data){
			this.datainfo = data
			this.visible = true
		},
		savefn(){
			const hide = message.loading("正在操作中")
			this.datainfo.hetonglingquinfo = this.datainfo.hetonglingquinfo.map(item=>{
				return {...item,isconfirm:1}
			})
			sunhao(this.datainfo).then(ret=>{
				this.visible=false
				hide()
				if(ret.code == 0){
					message.success("操作成功")
					this.reload()
				}
			}).catch(e=>{
				hide()
			})
		}	
	},
	props:[
		"reload"
	]
}
</script>
<style lang="less" scoped>
.inputcontainer{
	border-bottom: solid 1px #eee;
	padding-bottom: 20px;
	.itemcontainer{
		display: flex;
		align-items: center;
		margin: 10px 0 0 0;
		span{
			display: inline-block;
			width: 80px;
			text-align: right;
			padding-right: 10px;
		}
	}
}
</style>


